<template>
  <Sheet v-loading="loading.actions['password']">
    <h2>{{routeTitle}}</h2>
    <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px">
      <el-form-item label="帳號：" style="text-align:left; padding: 0.5em 0;">
        Admin (系統管理員)
      </el-form-item>
      <el-form-item label="輸入舊密碼：" prop="oldWords" class="redItem">
        <el-input type="password" v-model="form.oldWords"></el-input>
      </el-form-item>
      <el-form-item label="輸入新密碼：" prop="newPsd1" class="redItem">
        <el-input type="password" v-model="form.newPsd1"></el-input>
      </el-form-item>
      <el-form-item label="確認新密碼：" prop="newPsd2" class="redItem">
        <el-input type="password" v-model="form.newPsd2"></el-input>
      </el-form-item>
      <el-form-item label="" style="text-align:left; line-height: 2em; color: purple;">
        *密碼強度需求等級：中<br />
        *密碼最少須有8字元以上
      </el-form-item>
      <el-form-item label="密碼強度偵測" style="text-align:left; margin-left: 120px;" v-show="pwStrength>0">
        <span v-if="pwStrength==1" style="border-color: #FF0000; font-size: larger;">弱</span>
        <span v-else-if="pwStrength==2" style="border-color: #FF9900; font-size: larger;">中</span>
        <span v-else-if="pwStrength>2" style="border-color: #33CC00; font-size: larger;">強</span>
        <span v-else style="border-color: #eeeeee;">密碼強度偵測</span>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="save('ruleForm')"><i class="el-icon-check"></i>&nbsp;{{$t('Save_cmd')}}</el-button>
      </el-form-item>
    </el-form>
    <div style="text-align:left;">
        <font style="color:#c02c38;">* 紅色為必填欄位</font>
    </div>
  </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import routeTitleMixin from './routeTitleMixin';

export default {
  name: 'password',
  mixins: [routeTitleMixin],
  data () {
    return {
      roleType: 3,
      pwStrength: 0,
      form: {
        oldWords: '',
        newPsd1: '',
        newPsd2: ''
      },
      rules: {
        oldWords:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請輸入舊密碼'))
          } else {
            callback()
          }
        },trigger:"blur"}],
        newPsd1:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請設定密碼'))
          } else {
            if (this.form.newPsd2 !== '') {
              this.$refs.ruleForm.validateField('newPsd2')
            }
            callback()
          }
        } ,trigger:"blur"},
        { min: 8, max: 20, message: '長度在 8 到 20 個字元', trigger: 'blur' }],
        newPsd2:[{validator: (rule, value, callback) => {
          if (!value || value === '') {
            callback(new Error('請確認新密碼'))
          } else if (value !== this.form.newPsd1) {
            callback(new Error('兩次輸入密碼不一致!'))
          } else if (this.checkStrong(value) < 2) {
            callback(new Error('密碼強度不足!'))
          } else {
            callback()
          }
        },trigger:"blur"},
        { validator: (rule, value, callback) => {
          this.pwStrength = this.checkStrong(value)
          if (this.pwStrength < 2) {
            callback(new Error('密碼強度不足!'))
          } else {
            callback()
          }
        },trigger:"change"}]
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('config', ['config']),
  },
  methods: {
    ...mapActions('config', {
      setPassword: 'setPassword'
    }),
    resetData() {
      this.form.oldWords = '';
      this.form.newPsd1 = '';
      this.form.newPsd2 = '';
    },
    checkSaveData () {
      let msg = ''

      if (this.form.oldWords.length === 0) {
        msg = '請輸入舊密碼'
      } else if (this.form.newPsd1 !== this.form.newPsd2) {
        msg = '所輸入的密碼不一樣，請重新輸入'
      } else if (this.checkStrong(this.form.newPsd1) < 2) {
        msg = '密碼強度不足'
      }

      return msg
    },
    async save (ruleForm) {   
      this.$refs.ruleForm.validate(async (valid) => {
        console.log('======save ===== valid:' + valid)
        if (valid) {
          let pData = {
            text1: this.form.oldWords,
            text2: this.form.newPsd1
          }
          const ret = await this.setPassword({
            ...pData
          });

          if (ret.success) {
            switch (ret.instance) {
              case 0:
                  this.$message({
                    message: '恭喜您,存檔成功',
                    type: 'success'
                  })
                  break;
              case -2:
                  this.$message.error('對不起,舊密碼錯誤')
                  break;
              default:
                  this.$message.error('對不起,存檔失敗')
                  break;
            }
          } else {
            this.$message({
                            type: 'danger',
                            message: '操作失敗，請重試一次'
                          });
          } 
        } else {
          this.$message.error('對不起,驗證失敗')
          return false
        }
      })
    },
    chkPWStrong () {
      this.pwStrength = this.checkStrong(this.form.newPsd1)
    },
    charMode (iN) {
      let ret = 0

      if ((iN >= 48) && (iN <= 57)) { // 數字
        ret = 1
      } else if ((iN >= 65) && (iN <= 90)) { // 大寫字母
        ret = 2
      } else if ((iN >= 97) && (iN <= 122)) { // 小寫
        ret = 4
      } else { // 特殊字符
        ret = 8
      }

      return ret
    },
    bitTotal (num) {
      let modes = 0

      for (var i = 0; i < 4; i++) {
        if (num & 1) {
          modes++
        }
        num >>>= 1
      }

      return modes
    },
    checkStrong (sPW) {
      let modes = 0

      if (sPW.length <= 7) {
        return 1 // 密碼太短
      }

      for (var i = 0; i < sPW.length; i++) {
        // 測試每一個字符的類別並統計一共有多少種模式.
        modes |= this.charMode(sPW.charCodeAt(i))
      }

      return this.bitTotal(modes)
    }
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .redItem .el-form-item__label{
        color: #CC3300;
    }
</style>
